import React, { useState, useEffect, useRef } from 'react'
import { Table } from "antd";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from 'react-router-dom'
// import { adminMainUrl } from '../../../Config';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
// import Skeleton from 'react-loading-skeleton'
// import Api from '../../../Api';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Cookies from "js-cookie";
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import ReactPaginate from 'react-paginate';
import Beatloader from '../../../Common/Loaders/Beatloader';
import { adminMainUrl } from '../../../Config';
import { capitalizeFirstLetter } from '../../../HelperFunctions';
import { getSalesBillingList } from '../../../Redux/action/Account/BillingAction';
import axios from 'axios';

const BillingList = ({ headingText, trans_mode, impexp, service_type, billtype }) => {
    // console.log(billtype);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [pageLoader, setPageLoader] = useState(false);
    const token = Cookies.get("token");
    const user_id = Cookies.get("flexichain_user_id");
    const [dataSourcer, setDataSourcer] = useState(false);
    const [currentPage, setCurrentPage] = useState(() => {
        const params = new URLSearchParams(location.search); // Use URLSearchParams
        const savedPage = params.get("page");
        return savedPage ? Number(savedPage) : 1;
    });
    const [totalPages, setTotalPages] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const [paginationPage, setPaginationPage] = useState(0);
    const queryParams = new URLSearchParams(location.search);
    const queryString = new URLSearchParams(location.search).toString();

    const [exportLoading, setExportLoading] = useState(false);

    useEffect(() => {
        dispatch(getSalesBillingList(token, user_id, queryParams.get("page") ?? 1, impexp, trans_mode, billtype, queryString))
    }, [trans_mode, impexp, queryString, billtype]);

    const refreshData = () => {
        if (user_id && token) {
            dispatch(getSalesBillingList(token, user_id, queryParams.get("page") ?? 1, impexp, trans_mode, billtype, queryString));
        }
    };

    const resetFilters = () => {
        navigate(``)
    }

    const {
        loadingBillingList,
        BillingList,
        BillingListCurrentPage,
        BillingListTotalPage,
        BillingListTotalData
    } = useSelector(state => state.BillingReducer);

    const parseQueryParams = () => {
        const params = new URLSearchParams(location.search);

        return {
            search_by: params.get("search_by") || "",
            start_date: params.get("start_date") || "",
            end_date: params.get("end_date") || "",
            payment_terms: params.get("payment_terms") || "",
        };
    };

    let formik = useFormik({
        initialValues: parseQueryParams(),
        onSubmit: (values) => {
            const params = new URLSearchParams(location.search);
            Object.keys(values).forEach((key) => {
                if (values[key]) {
                    params.set(key, values[key]);
                } else {
                    params.delete(key);
                }
            });

            if (!params.has("page")) {
                params.set("page", "1");
            } else {
                params.set("page", "1");
            }
            const queryString = params.toString();
            navigate(`${location.pathname}?${queryString}`);
            const currentPage = 1;
            const ITEMS_PER_PAGE = 10;
            dispatch(getSalesBillingList(token, user_id, queryParams.get("page") ?? 1, impexp, trans_mode, billtype, queryString));
        },
    });

    const columns = [
        { title: "#", dataIndex: "sno", key: "sno" },
        { title: "Job Order No.", dataIndex: "job_order_no", key: "job_order_no" },
        { title: "Invoice Series", dataIndex: "invoice_series", key: "invoice_series" },
        { title: "Invoice Number", dataIndex: "invoice_number", key: "invoice_number" },
        { title: "Invoice Date", dataIndex: "invoice_date", key: "invoice_date" },
        { title: "Due Date", dataIndex: "due_date", key: "due_date" },
        { title: "Payment Terms", dataIndex: "payment_terms", key: "payment_terms" },
        { title: "Reference No.", dataIndex: "reference_no", key: "reference_no" },
        { title: "Net Receivable Amount", dataIndex: "net_receivable_amount", key: "net_receivable_amount" },
        { title: "Current Status", dataIndex: "current_status", key: "current_status" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];

    useEffect(() => {
        // console.log("BillingListPickedUser", BillingListPickedUser)
        if (loadingBillingList) {
            setPageLoader(true);
        } else {
            setPageLoader(false);
        };

        if (BillingList) {
            let arr = BillingList?.map((value, i) => ({
                key: i + 1,
                sno: Number(paginationPage) * 10 + (i + 1),
                job_order_no: value.sales_billing_job_order_details ? value.sales_billing_job_order_details.job_order_unique_no ?? "-" : "-",
                invoice_series: value?.invoice_series ?? "-",
                invoice_number: value?.invoice_number ?? "-",
                invoice_date: value?.invoice_date ?? "-",
                due_date: value?.due_date ?? "-",
                payment_terms: value?.payment_terms ?? "-",
                reference_no: value?.reference_no ?? "-",
                net_receivable_amount: value?.net_receivable_amount ? `${value?.net_receivable_amount}` : "0",
                current_status: value?.current_status,
                action: (
                    <>
                        <div className="d-flex">
                            <div className="dropdown table-action">
                                <Link to="#" className="action-icon" data-bs-toggle="dropdown" >
                                    <i className="fa fa-ellipsis-v"></i>
                                </Link>
                                {

                                    <div className="dropdown-menu dropdown-menu-right">
                                        <div className="dropdown-item" onClick={() => {
                                            navigate(`/flexichain/${billtype == 'customer' ? 'edit-customer-billing' : 'edit-billing'}/${btoa(value.id)}`)
                                        }}>
                                            <i className="ti ti-eye text-blue-light"></i> Edit
                                        </div>

                                    </div>
                                }
                            </div>
                        </div>

                    </>
                ),
            }));
            setDataSourcer(arr);
        }

        if (BillingListTotalData) {
            setTotalItems(BillingListTotalData);
        }

        if (BillingListTotalPage) {
            setTotalPages(BillingListTotalPage)
        }
    }, [loadingBillingList, BillingList, BillingListCurrentPage, BillingListTotalPage, BillingListTotalData]);

    const handlePageClick = (selectedObject) => {
        const selectedPage = selectedObject.selected + 1;
        const params = new URLSearchParams(location.search);
        setCurrentPage(selectedPage);
        params.set("page", selectedPage);
        navigate(`?${params.toString()}`);
    };

    const handleExportCSV = async () => {
        try {
            setExportLoading(true);

            let config = {
                headers: {
                    "auth-token": token,
                    "user_id": user_id,
                    "Content-Type": "application/json",
                },
                responseType: "blob",
            };

            const extraBody = {};

            if (location.search) {
                const params = new URLSearchParams(location.search);

                params.forEach((value, key) => {
                    extraBody[key] = value;
                });
            }

            const body = {
                airsea: trans_mode,
                impexp: impexp,
                ...extraBody,
            };
            if (billtype == "customer") { body.billtype = billtype }

            const response = await axios.post(
                `${adminMainUrl}/api/account/billing-export`,
                body,
                config
            );

            const blob = new Blob([response.data], {
                type: "text/csv;charset=utf-8;",
            });

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = `Billing_Report_${Date.now()}.csv`;

            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.log(err);
            toast.error("Failed to export billing report.");
        } finally {
            setExportLoading(false);
        }
    };

    return (
        <>
            {
                pageLoader ?
                    <Beatloader />
                    :
                    <div className="page-wrapper">
                        <div className={"content m-3"}>
                            <div className="row">
                                <div className="col-md-12">
                                    {/* Page Header */}
                                    <div className="page-header">
                                        <div className="row align-items-center">
                                            <div className="col-8">
                                                <h4 className="page-title">
                                                    {headingText} <span className="count-title">{BillingListTotalData ? BillingListTotalData : 0}</span>
                                                </h4>
                                            </div>
                                            {billtype == "sales" ? <div className="col-4 text-end">
                                                <div className="mb-2">
                                                    <Link to='/flexichain/add-billing' className="btn btn-sm btn-primary">+ Add Billing</Link>
                                                </div>
                                            </div> : null}
                                        </div>
                                    </div>
                                    {/* /Page Header */}
                                </div>
                            </div>
                            <form onSubmit={formik.handleSubmit}>
                                <div className="card">
                                    <div className="card-header py-2">
                                        {/* Search */}
                                        <div className="row g-3 align-items-end">

                                            {/* Search By */}
                                            <div className="col-md-3">
                                                <label htmlFor="search_by" className="form-label">
                                                    Search By
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    id="search_by"
                                                    name="search_by"
                                                    placeholder="Invoice No / Series"
                                                    value={formik.values.search_by}
                                                    onChange={formik.handleChange}
                                                />
                                            </div>

                                            {/* Start Date */}
                                            <div className="col-md-2">
                                                <label htmlFor="start_date" className="form-label">
                                                    Start Date
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control form-control-sm"
                                                    id="start_date"
                                                    name="start_date"
                                                    value={formik.values.start_date}
                                                    onChange={formik.handleChange}
                                                />
                                            </div>

                                            {/* End Date */}
                                            <div className="col-md-2">
                                                <label htmlFor="end_date" className="form-label">
                                                    End Date
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control form-control-sm"
                                                    id="end_date"
                                                    name="end_date"
                                                    value={formik.values.end_date}
                                                    onChange={formik.handleChange}
                                                />
                                            </div>

                                            {/* Payment Terms */}
                                            <div className="col-md-3">
                                                <label htmlFor="payment_terms" className="form-label">
                                                    Payment Terms
                                                </label>
                                                <select
                                                    className="form-control form-control-sm"
                                                    id="payment_terms"
                                                    name="payment_terms"
                                                    value={formik.values.payment_terms}
                                                    onChange={formik.handleChange}
                                                >
                                                    <option value="">-Select an option-</option>
                                                    {
                                                        [
                                                            '1 Week',
                                                            '15 Days',
                                                            '1 Month',
                                                            'Quarterly',
                                                            'Half Yearly', 'Yearly'
                                                        ].map((v, i) => {
                                                            return <option value={v} key={i}>{v}</option>
                                                        })
                                                    }

                                                </select>
                                            </div>

                                            {/* Search Button */}
                                            <div className="col-md-2">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <button
                                                            type="submit"
                                                            className="btn btn-primary w-100"
                                                        >
                                                            Search
                                                        </button>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <Link
                                                            to={`/flexichain/${billtype == "customer" ? `customer-billing` : `billing`}/${trans_mode}/${impexp}`}
                                                            className="btn btn-outline-primary"
                                                            onClick={() => formik.resetForm()}
                                                        >
                                                            Reset
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        {/* /Search */}
                                    </div>
                                    <div className="card-body py-2">

                                        <>
                                            {/* Air / Sea Tabs */}
                                            <div
                                                className="d-flex justify-content-between align-items-center"
                                                style={{
                                                    overflowX: "auto",
                                                    overflowY: "hidden",
                                                }}
                                            >
                                                <ul
                                                    className="nav mx-1 nav-pills nav-slider my-2 border-2 custom-tabs"
                                                    role="tablist"
                                                >
                                                    <li className="nav-item">
                                                        <button
                                                            type="button"
                                                            className={`nav-link fw-semibold custom-tab position-relative ${trans_mode === "air" ? "active" : ""
                                                                }`}
                                                            onClick={() => navigate(`/flexichain/${billtype == "customer" ? 'customer-billing' : 'billing'}/air/export`)}
                                                        >
                                                            Air
                                                        </button>
                                                    </li>

                                                    <li className="nav-item">
                                                        <button
                                                            type="button"
                                                            className={`nav-link fw-semibold custom-tab position-relative ${trans_mode === "sea" ? "active" : ""
                                                                }`}
                                                            onClick={() => navigate(`/flexichain/${billtype == "customer" ? 'customer-billing' : 'billing'}/sea/export`)}
                                                        >
                                                            Sea
                                                        </button>
                                                    </li>
                                                </ul>

                                                <button
                                                    className="btn btn-primary btn-sm ms-3"
                                                    onClick={handleExportCSV}
                                                    disabled={exportLoading}
                                                >
                                                    {exportLoading ? (
                                                        <>
                                                            <span
                                                                className="spinner-border spinner-border-sm me-2"
                                                                role="status"
                                                                aria-hidden="true"
                                                            ></span>
                                                            Exporting...
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="ri-download-2-line me-1"></i>
                                                            Export CSV
                                                        </>
                                                    )}
                                                </button>
                                            </div>

                                            {/* Export / Import Tabs */}
                                            <div
                                                className=""
                                                style={{
                                                    width: "auto",
                                                    overflowX: "auto",
                                                    overflowY: "hidden",
                                                    scrollBehavior: "smooth",
                                                }}
                                            >
                                                <ul
                                                    className="nav mx-1 nav-pills nav-slider my-2 border-2 custom-tabs"
                                                    role="tablist"
                                                >
                                                    <li className="nav-item" role="presentation">
                                                        <button
                                                            type="button"
                                                            className={`nav-link fw-semibold custom-tab position-relative ${impexp === "export" ? "active" : ""
                                                                }`}
                                                            onClick={() =>
                                                                navigate(`/flexichain/${billtype == "customer" ? `customer-billing` : `billing`}/${trans_mode}/export`)
                                                            }
                                                        >
                                                            Export
                                                        </button>
                                                    </li>

                                                    <li className="nav-item" role="presentation">
                                                        <button
                                                            type="button"
                                                            className={`nav-link fw-semibold custom-tab position-relative ${impexp === "import" ? "active" : ""
                                                                }`}
                                                            onClick={() =>
                                                                navigate(`/flexichain/${billtype == "customer" ? `customer-billing` : `billing`}/${trans_mode}/import`)
                                                            }
                                                        >
                                                            Import
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </>

                                        <div className="table-responsive custom-table query-list-table">
                                            <Table className="table datanew dataTable no-footer"
                                                // rowSelection={rowSelection} 
                                                dataSource={dataSourcer}
                                                columns={columns}
                                                pagination={false}
                                                rowClassName={(record) => (record.is_priority === "YES" ? "prior-query" : "")}
                                            />
                                        </div>

                                        <div className="row align-items-center">
                                            {BillingList?.length > 0 && <div className="pagination-controls my-5 d-flex justify-content-center align-items-center react-custom-paginate">
                                                <ReactPaginate
                                                    previousLabel={<img src="/img/right.png" alt="Previous" />}
                                                    nextLabel={<img src="/img/left.png" alt="Next" />}
                                                    breakLabel="..."
                                                    breakClassName="break-me"
                                                    pageCount={totalPages}
                                                    marginPagesDisplayed={2}
                                                    pageRangeDisplayed={5}
                                                    onPageChange={handlePageClick}
                                                    containerClassName="pagination"
                                                    activeClassName="active"
                                                    forcePage={currentPage - 1}
                                                />
                                            </div>
                                            }
                                        </div>

                                    </div>
                                </div>
                            </form>
                        </div >
                    </div >
            }

        </>

    )
}

export default BillingList